import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_LOADING, SET_INBOX, SET_INBOXES } from './mutations';

import { inboxes as inboxesApi } from '@/api';
import { arrayToObject } from '@/utils/helpers';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

export const fetchInboxes = buildActionObject('fetchInboxes');
export const createInbox = buildActionObject('createInbox');
export const partialUpdateInbox = buildActionObject('partialUpdateInbox');

// set_<stuff> actions here only commit mutations, they don't fetch from server
export const setInbox = buildActionObject('setInbox');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchInboxes.action]({ commit }) {
		commit(SET_LOADING, true);
		try {
			commit(SET_INBOXES, arrayToObject(await inboxesApi.list()));
		} finally {
			commit(SET_LOADING, false);
		}
	},
	async [createInbox.action]({ commit }, payload) {
		const resp = await inboxesApi.create(payload);
		commit(SET_INBOX, resp);
		return resp;
	},
	async [partialUpdateInbox.action]({ commit }, { id, fields }) {
		const resp = await inboxesApi.partialUpdate(id, fields);
		commit(SET_INBOX, resp);
		return resp;
	},
	async [setInbox.action]({ commit }, inbox) {
		commit(SET_INBOX, inbox);
	},
};

export default actions;
